import { SubmitedFilterDates } from 'components/miscellaneous/CalendarFilter'
import { Dispatch, SetStateAction, createContext } from 'react'

export type FilterDate = SubmitedFilterDates & {
  label?: string
  value?: string
}

export type CalendarFilterTemplateType = {
  onSubmitFilter: (values: SubmitedFilterDates) => void
  filterDate?: FilterDate
  setFilterDate: Dispatch<SetStateAction<FilterDate>>
}

const defaultValues = {
  onSubmitFilter: () => {},
  filterDate: {},
  setFilterDate: () => {},
}

const SidebarContext = createContext<CalendarFilterTemplateType>(defaultValues)

export default SidebarContext
